module.exports = require("extensions-slots-core");;